import React, { useContext } from "react";
import { UserProfileContext } from "../../utils/UserProfileContext";
import Login from "../Login/Login";
import { Brandmark } from "../Logo/Logo";
import Logout from "../Logout/Logout";
import "./Navbar.css";

function Navbar() {
  const { userData } = useContext(UserProfileContext);

  const LoggedIn = () => {
    return (
      <>

          <Brandmark width={"200px"} margin={"0"} align={"left"} />
          <div className="menu">

          </div>
          <Logout />

      </>
    );
  };

  const LoggedOut = () => {
    return (
      <>
        <Brandmark width={"200px"} margin={"2vh 0"} align={"left"} />
        <div className="menu">
          <button>HOME</button>
          <button>ABOUT</button>
          <button>PRICING</button>
        </div>
        <Login />
      </>
    );
  };

  return (
    <>
      <div className="navbar-wrapper">
        <div className="navbar">{userData ? <LoggedIn /> : <LoggedOut />}</div>
      </div>
    </>
  );
}

export default Navbar;
